import {encryptAES256} from './api';

export const authEncryptAes256 = (
  AESkey: string,
  id: string,
  password: string,
) => {
  const iv = AESkey.slice(0, 16);
  const currentTimestamp = Math.floor(Date.now() / 1000);

  const auth1 = AESkey;
  const auth2 = encryptAES256(password + currentTimestamp, AESkey, iv);
  const auth3 = encryptAES256(id, AESkey, iv);
  const auth = auth1 + auth2 + auth3;

  return auth;
};
